module.exports = __webpack_public_path__ + "src/assets/img/Saly-11.0fd1d8c3.webp";